export const ArpeggioTopOptionsCard = props => {
  let monoBtn = ""
  let polyBtn = ""

  if (!props.monoPolyState) {
    monoBtn = 
      <div className="monoBtn"  data-action="monoState" title="Z"> 
        <img draggable="false" src={props.imgSrc[15]} className="arpeggioFullImage noContextMenu" alt="mono state on" onClick={props.handleClick} />
      </div>    
  }
  else {
    monoBtn = 
      <div className="monoBtn"  data-action="monoState" title="Z"> 
        <img draggable="false" src={props.imgSrc[16]} className="arpeggioFullImage noContextMenu" alt="mono state off" onClick={props.handleClick} />
      </div>  
  }

  if (props.monoPolyState) {
    polyBtn = 
      <div className="polyBtn" data-action="polyState" title="X"> 
        <img draggable="false" src={props.imgSrc[21]} className="arpeggioFullImage noContextMenu" alt="poly state on" onClick={props.handleClick} />
      </div>   
  }
  else {
    polyBtn = 
      <div className="polyBtn" data-action="polyState" title="X"> 
        <img draggable="false" src={props.imgSrc[22]} className="arpeggioFullImage noContextMenu" alt="poly state off" onClick={props.handleClick} />
      </div> 
  }

  

  return (
    <div className="arpeggioTopOptionsContainer">
      <div className="monoPolyBtnsContainer">
        {monoBtn}
        {polyBtn}
        
      </div>
      <div className="bpmDisplayBtnsContainer">
        <div className="bpmDisplayBtn" data-action="bpmDisplay" data-position="1" title="C"> 
          <img draggable="false" src={props.imgSrc[10]} className="arpeggioFullImage noContextMenu" alt="bpmDisplay1 state on" onClick={props.handleClick} />
        </div>
        <div className="bpmDisplayBtn" data-action="bpmDisplay" data-position="2" > 
          <img draggable="false" src={props.imgSrc[11]} className="arpeggioFullImage noContextMenu" alt="bpmDisplay2 state on" onClick={props.handleClick} />
        </div>
        <div className="bpmDisplayBtn" data-action="bpmDisplay" data-position="3" > 
          <img draggable="false" src={props.imgSrc[12]} className="arpeggioFullImage noContextMenu" alt="bpmDisplay3 state on" onClick={props.handleClick} />
        </div>
        <div className="bpmDisplayBtn" data-action="bpmDisplay" data-position="4" > 
          <img draggable="false" src={props.imgSrc[13]} className="arpeggioFullImage noContextMenu" alt="bpmDisplay4 state on" onClick={props.handleClick} />
        </div>
        <div className="bpmDisplayBtn" data-action="bpmDisplay" data-position="5" title="V"> 
          <img draggable="false" src={props.imgSrc[14]} className="arpeggioFullImage noContextMenu" alt="bpmDisplay5 state on" onClick={props.handleClick} />
        </div>
      </div>
    </div>
  )
}
